import React from 'react';
import classNames from 'classnames';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { IParticipantsPair, IParticipant, IResults } from 'twain-sport-fe-mono/interfaces';
import { ResultReason } from 'twain-sport-fe-mono/enums';
import { loopPair } from 'twain-sport-fe-mono/utils';
import { VideoResultScore } from './VideoResultScore';
import classes from './VideoResultSpinner.module.scss';

interface IProps {
    participants: IParticipantsPair;
    results: IResults;
    isFullscreen?: boolean;
    animationDuration: number;
    className?: string;
}

const formatPoints = (results: IResults, participant: IParticipant) =>
    results.participants[participant.code]?.points?.toString().padStart(2, '0');

export const VideoResultSpinner: React.FC<IProps> = (props) => {
    const [showStatus, setShowResult] = React.useState<boolean>(false);
    const timeout = React.useRef<number>(0);

    React.useEffect(() => {
        if (!props.results) {
            return undefined;
        }

        const isTie = props.results.resultReason !== ResultReason.REGULAR;

        if (isTie) {
            timeout.current = window.setTimeout(
                () => setShowResult(true),
                props.animationDuration * 1000,
            );
        }

        return () => {
            window.clearTimeout(timeout.current);
        };
    }, [!!props.results]);

    if (!props.results) {
        return null;
    }

    return (
        <div
            className={classNames(classes.container, props.className, {
                [classes.fullscreen]: props.isFullscreen,
            })}
        >
            <div className={classes.case}>
                {loopPair<IParticipant>(props.participants).map((participant) => (
                    <div className={classes.participant} key={participant.code}>
                        <div className={classes.block}>
                            <div className={classes.jerseyNumber}>#{participant.jerseyNumber}</div>
                            <div className={classes.nickname}>{participant.nickname}</div>
                        </div>
                        <VideoResultScore
                            animationDuration={props.animationDuration}
                            className={classes.block}
                            points={formatPoints(props.results, participant)}
                        />

                        <div className={classNames(classes.block, classes.result)}>
                            {props.results.participants[participant.code] && (
                                <>
                                    <span className={classes.numbers}>
                                        {props.results.participants[participant.code].totalHits}/
                                        {props.results.participants[participant.code].totalShots} (
                                        {props.results.participants[participant.code].accuracy}
                                        %)
                                    </span>
                                    {props.results.winner === participant.code && showStatus && (
                                        <div className={classes.status}>
                                            {translationProvider.string(
                                                `win_on_${props.results.resultReason.toLowerCase()}`,
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
